const company = {
  company: {
    pageHeader: 'Profilo aziendale',
    branchProfile: 'Profilo filiale',
    addBranchOffice: 'Aggiungi filiale',
    companyDetails: 'Dettagli azienda',
    branchDetails: 'Dettagli filiale',
    companyName: 'Nome azienda',
    branchName: 'Nome filiale',
    websiteURL: 'URL sito Web',
    url: 'URL',
    yearFounded: 'Anno di fondazione',
    companyLogo: "Logo dell'azienda",
    imageFormatDescription: 'Deve essere un file JPEG, GIF o PNG con dimensioni massime di 4MB.',
    imageShapeDescription:
      "Per ottenere i migliori risultati, consigliamo un'immagine quadrata con sfondo trasparente larga almeno 400px e alta 400px.",
    noFile: 'Nessun file selezionato',
    companyDescription: "Descrizione dell'azienda",
    myTestEdit: 'Modifica del mio testo',
    customerWelcomeEmail: 'Messaggio e-mail di benvenuto ai clienti',
    testEditMessage: 'modifica messaggio e-mail di test',
    companyDescriptionTooltip:
      'Il testo inserito qui apparirà nelle visualizzazioni pubbliche dei sistemi installati dalla tua azienda. Puoi includere le informazioni di contatto per aiutare a generare contatti di vendita dai visitatori di queste pagine.',
    editCompanyInformation: "Modifica informazioni sull'azienda",
    welcomeEmailDescription:
      "Il testo inserito qui apparirà nell'e-mail di benvenuto inviata ai nuovi clienti quando viene creato un account Enlighten. Puoi scegliere di includere il logo della tua azienda in questo messaggio.",
    editWelcomeMessage: 'Modifica messaggio e-mail di benvenuto ai clienti',
    checkboxDisplayLogo: "Visualizza logo aziendale nell'e-mail di benvenuto ai clienti",
    previewEmail: "Anteprima dell'e-mail di benvenuto ai clienti",
    contactDetails: 'Dettagli di contatto',
    streetAddress: 'Indirizzo',
    streetAddress2: 'Indirizzo 2',
    city: 'Città',
    zipCode: 'CAP/Codice postale',
    customerSupport: "Contatti dell'assistenza clienti",
    country: 'Nazione',
    state: 'Stato/Provincia',
    contactOwnerDescription: 'per contattare il proprietario del sistema / proprietario di casa',
    businessContacts: 'Contatti commerciali',
    sameCheckbox: "Uguali all'assistenza clienti",
    contactEnphaseDescription: 'per contattare Enphase',
    installationDetails: "Dettagli dell'installazione",
    servicesOffered: 'Servizi offerti',
    installationType: 'Tipo di installazione',
    salesEmployeeNumber: 'Numero di dipendenti nelle vendite',
    workmanshipWarranty: 'Garanzia da difetti di fabbricazione (anni)',
    installationEmployeeNumber: 'Numero di dipendenti che eseguono installazioni',
    typicalInstallationsYear: "Installazioni tipiche (all'anno)",
    typicalInstallationsMonth: 'Installazioni tipiche (kW/anno)',
    enphaseShare: 'Quota Enphase delle installazioni',
    sgipDeveloper: 'Sei uno sviluppatore SGIP?',
    sgipDeveloperTooltip: 'Seleziona se sei registrato come Sviluppatore SGIP su selfgenca.com',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'Chiave sviluppatore SGIP',
    businessLicenses: 'Licenze commerciali',
    addNewLicense: 'AGGIUNGI NUOVA LICENZA',
    licenseType: 'Tipo di licenza',
    licenseNo: 'Numero licenza',
    none: 'Nessuna',
    licensingBoard: 'Organo preposto al rilascio delle licenze',
    licensingAuthority: 'Autorità preposta al rilascio delle licenze',
    expiryDate: 'Data di scadenza',
    profileLinks: 'Link al profilo',
    yelpAccountLink: "Link all'account Yelp",
    rating: 'Valutazione: ',
    reviews: 'Recensioni: ',
    yelpAccountLinkTooltip:
      'Per ottenere questo link, vai al tuo profilo Yelp e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    yelpAccountLinkError:
      'Non siamo riusciti a recuperare il tuo profilo Yelp. Controlla nuovamente il link al profilo inserito',
    googlePlaceId: 'ID Google Places',
    clickHere: 'Fai clic qui',
    findPlaceId: 'per trovare il tuo ID Google Places',
    placeIdError:
      "Non siamo in grado di di trovare una posizione valida per questo ID. Controlla nuovamente l'ID che hai inserito.",
    solarProfileLink: 'Link al SolarReviews',
    solarProfileLinkTooltip:
      'Per ottenere questo link, vai al tuo profilo SolarReviews.com e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    bbbProfileLink: 'Link al profilo BBB',
    bbbProfileLinkTooltip:
      'Per ottenere questo link, vai al tuo profilo BBB.org e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    solarQuotesProfileLink: 'Link al profilo Solarquotes',
    solarQuotesTooltip:
      'Per ottenere questo link, vai al tuo profilo solarquotes.com.au e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    productReviewProfileLink: 'Link al profilo ProductReview',
    productReviewTooltip:
      'Per ottenere questo link, vai al tuo profilo productreview.com.au e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    trustPilotLink: 'Link al profilo Trustpilot',
    trustPilotTooltip:
      'Per ottenere questo link, vai al tuo profilo trustpilot.com e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    facebookLink: 'Link al profilo Facebook',
    facebookTooltip:
      'Per ottenere questo link, vai al tuo profilo Facebook.com e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    justDialLink: 'Link al profilo Just Dial',
    justDialTooltip:
      'Per ottenere questo link, vai al tuo profilo justdial.com e copia il link/l’URL nella barra degli indirizzi del tuo browser Internet',
    listOfReferenceSystems: 'Elenco dei sistemi di riferimento',
    referenceListDescription:
      'Il tuo elenco di riferimento si aggiorna automaticamente per mostrare i sistemi che i proprietari hanno scelto di condividere. I sistemi elencati qui hanno almeno 100kWh di resa energetica',
    requestSystemAccess: 'Richiedi accesso al sistema',
    maintainer: 'Responsabile della manutenzione',
    view_only: 'Solo visualizzazione',
    linkRequestAccess:
      "Invia questo link ai proprietari del sistema per richiedere l'accesso al loro sistema in Enlighten",
    fieldRequired: 'Questo campo è obbligatorio.',
    validEmail: 'Inserire un indirizzo e-mail valido.',
    validPhone: 'Inserire un numero di telefono valido.',
    supportContact: 'Compilare almeno uno dei cinque campi precedenti (Telefono/E-mail).',
    serviceRequired: 'Almeno un tipo di servizio è obbligatorio',
    installationRequired: 'Almeno un tipo di installazione è obbligatorio',
    minLength: 'La lunghezza minima consentita è 2',
    maxLength: 'La lunghezza massima consentita è 15',
    dateWarning: 'Avvertenza: Questa licenza verrà considerata scaduta perché la data di scadenza è nel passato',
    correctValue: 'Inserire un valore inferiore o uguale a\xa0',
    feinLength: 'Inserire un numero ci 9 cifre',
    less_than_25: 'Meno del 25%',
    between_25_50: 'Dal 25% al 50%',
    between_50_90: 'Dal 50% al 90%',
    greater_than_90: 'Superiore al 90%',
    roofing: 'Tetti',
    solar: 'Solare',
    storage: 'Spazio di accumulazione',
    electrical: 'Elettrico',
    ev_charger: 'Caricabatterie EV',
    others: 'Altro',
    commercial: 'Commerciale',
    residential: 'Residenziale',
    new_homes: 'Case nuove',
    installer: 'Installatore',
    roles_distributor: 'Distributore',
    roles_support: 'Azienda di supporto',
    cec: 'CEC',
    electrical_contract: 'Contratto elettrico',
    abn_number: 'Numero ABN',
    acn_number: 'Numero ACN',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    selectCountry: 'Seleziona il paese',
    yellowPageLink: 'Collegamento alle pagine gialle',
    yellowPageTooltip: `Per ottenere questo link, accedere al proprio profilo sul sito https://www.pagesjaunes.fr/ e copiare il link/l’URL nella barra degli indirizzi del browser Internet.`,
    enrQualityDirectoryLink: 'Qualit’Enr annuale',
    enrQualityDirectoryTooltip: `Per ottenere questo link, accedere al proprio profilo sul sito https://www.qualit-enr.org/annuaire/ e copiare il link/l’URL nella barra degli indirizzi del browser Internet.`,
    validChamberNumber: 'Inserimento non valido! Sono richiesti almeno 8 caratteri per il numero della Camera di Commercio',
    chamberofcommerce : 'Numero della Camera di Commercio',
  }
};

export default company;
